import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FiAlertCircle, FiCheck, FiX } from "react-icons/fi";
import BrandMark from "./BrandMark";
import siteConfig from "../siteConfig";
import "../css/paysuccess.css";

const states = {
  success: {
    icon: <FiCheck />,
    eyebrow: "Checkout return received",
    title: "Payment verification is pending.",
    body: "The hosted checkout returned to its success address. This does not by itself prove that funds settled or that the order was accepted. Keep your cart and payment reference until customer care confirms the order.",
  },
  cancel: {
    icon: <FiX />,
    eyebrow: "Checkout cancelled",
    title: "Your cart is still available.",
    body: "The hosted checkout returned by its cancellation address. No completed order is assumed. If your bank shows an authorisation, do not submit again; email customer care with the reference so it can be checked.",
  },
  failed: {
    icon: <FiAlertCircle />,
    eyebrow: "Checkout could not continue",
    title: "No order confirmation was created.",
    body: "Return to the cart and check the details before trying again. If a payment appears on your account, contact customer care before making another attempt.",
  },
  unknown: {
    icon: <FiAlertCircle />,
    eyebrow: "Payment status unavailable",
    title: "We cannot determine a result from this page.",
    body: "Open this page only through the hosted checkout return flow. A URL value is never used as proof of payment.",
  },
};

function PaymentResult() {
  const [params] = useSearchParams();
  const key = params.get("state");
  const content = states[key] || states.unknown;
  return (
    <main className="successDiv">
      <div className="payment-result-brand"><Link to="/"><BrandMark compact /></Link></div>
      <div className="success-container">
        <div className="checkmark-circle">{content.icon}</div>
        <p className="eyebrow">{content.eyebrow}</p>
        <h1>{content.title}</h1>
        <p>{content.body}</p>
        <div className="result-actions"><Link className="button-link" to="/cartpage">Return to cart</Link><a href={`mailto:${siteConfig.contact.email}`}>Contact {siteConfig.contact.email}</a></div>
      </div>
    </main>
  );
}

export default PaymentResult;
